// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__fHHMB","title":"Images90_title__yRZXJ","images":"Images90_images__3iV_9"};